export class NormalizeResult<T>
{
  resultIds: number[]
  entities: Map<number, T>
}